import ProductImage from '@v2/shared/components/ProductImage';
import Status from '../AutoRenewals/Status';
import Box, { BoxLabel } from './Box';
import { AutoRenewalDetail } from './types';

/**
 * What the subscription is, and who it goes to — the half of the page that does not
 * change no matter what state it is in.
 *
 * `sku.text` is a term written as "12 Issues / 1 Year"; only the part before the slash is
 * shown, as at the source, because the years are the same information said twice.
 */
export default function SubscriptionInfo({ autoRenewal }: { autoRenewal: AutoRenewalDetail }) {
  const { product, sku, delivery_address: address, status } = autoRenewal;

  return (
    <div className="grid grid-cols-6 gap-5">
      <ProductImage product={product} className="col-span-2 w-full" />

      <div className="col-span-4">
        <div className="mb-7">
          <Status status={status} />
          {/*
            * An h1 where the source had an h3. Nothing else on the page is a heading —
            * the layout draws no title — so this is the page's, and a document whose only
            * heading is a level three is one a screen reader reads as having a gap in it.
            * The size classes are the source's, so it renders identically.
            */}
          <h1 className="font-semibold text-lg my-0">{product.name}</h1>
          <p className="text-slate-600 font-medium text-sm">{sku.text.split('/')[0].trim()}</p>
        </div>

        <BoxLabel>Recipient</BoxLabel>
        <Box type="dashed" padding="snug" className="text-sm">
          <div className="font-semibold">{address.name}</div>
          <div className="text-xs font-medium">
            <div>{address.address1}</div>
            {address.address2 && <div>{address.address2}</div>}
            <div>
              {address.city}, {address.state} {address.zip}
            </div>
          </div>
        </Box>
      </div>
    </div>
  );
}
